import moment from "moment";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Loader from "shared/common/loader";

const BarAllocationInvoice = ({ invoiceData, invoiceLoading }) => {

    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<any>(true);


    const metals = {
        "Ag": "Silver",
        "Au": "Gold",
        "Pt": "Platinum",
        "Pd": "Palladium"
    }

    useEffect(() => {
        if (invoiceData) {
            setData(invoiceData)
            setLoading(false)
        }
    }, [invoiceData])

    return (
        <>
            {loading && <Loader />}
            <Table className='mb-0 w-100 txn__table' striped hover responsive>
                <thead>
                    <tr>
                        <th >
                            Warehouse
                        </th>
                        <th>{" "}</th>
                        <th>Bar No</th>
                        <th>VSO Id</th>
                        <th>Metal</th>
                        <th>
                            Order No
                        </th>
                        <th>Order Date</th>
                        <th>Quantity</th>
                        <th>vso Receipt</th>


                    </tr>
                </thead>
                <tbody>
                    {invoiceLoading ? (
                        <tr>
                            <td className="text-center" colSpan={9}>
                                Loading...
                            </td>
                        </tr>
                    ) : data.length === 0 ? (
                        <tr>
                            <td className="text-center" colSpan={9}>
                                No data available
                            </td>
                        </tr>
                    ) : (
                        data?.map((metal: any, index: number) => (
                            <tr key={index}>
                                <td className="min">{metal.warehouseId}</td>
                                <td> </td>
                                <td>{metal.barNo}</td>
                                <td>{metal.vsoId}</td>
                                <td>{metals[metal.metalCode]}</td>
                                <td>{metal.ebOrderRef}</td>
                                <td>
                                    {moment(metal.orderDate).format("DD-MMM-yyyy  hh:mm:ss A")}
                                </td>
                                <td>{metal.quantity} g</td>

                                {metal.pdfUrl ?
                                <td>
                                    {metal.pdfUrl ? (
                                        <a href={metal.pdfUrl} target="_blank" rel="noopener noreferrer">
                                            View
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </td>:
                                <td>-</td>
                                }
                                
                            </tr>
                        ))
                    )}

                </tbody>
            </Table>

        </>
    )
}

export default BarAllocationInvoice;